<template>
  <section class='leaveStu'>
    <Row>
      <Breadcrumb>
        <BreadcrumbItem>媒体发布</BreadcrumbItem>
        <BreadcrumbItem>菜单管理</BreadcrumbItem>
      </Breadcrumb>
    </Row>
    <Row xs="20" sm="16" md="12" lg="8">


      <ul class='conheadRight'>
        <i-button type="error" @click='newGrade'>新增顶部菜单</i-button>
      </ul>
    </Row>
    <section class='tabelContent'>
      <Collapse v-model="value1" @on-change='switchPanel' :simple='true' :accordion='true'>
        <Panel v-for='(item, index) in gradelist' v-if='item.parentId == 0' :name="'name' + item.id" :key='index'>

          <b id='gradenames'>{{ item.name }}</b> <span id='sortStyle'>排序：{{ item.rank }}</span>
          <Button type="dashed" size='small' @click.stop='editGrade(item, index)' icon="ios-list removeHome"
            class='removeGw'>编辑</Button>

          <ul slot="content" class='classes'>
            <!-- <li v-for='(items,indexs) in item.children' :keys='indexs' class='classlist' @click='updateData(items,item.guid,index)'> -->
            <li v-for='(items, indexs) in gradelist' v-if='items.parentId == curId' :keys='indexs' class='wjnolit'
              @click='updateData(items, item.guid, index)'>

              <Icon :type="items.icon" size='30' style='margin-top:20px;' />

              <h3> {{ items.name }}</h3>

              <span>排序：{{ items.rank }}</span>

            </li>
            <!-- <li  class='classlist' @click='newClass(item.guid,index)'> -->
            <li class='wjnolit' @click='newClass(item.id, index)'>
              <Icon type="ios-add-circle-outline" size='40' style='margin-top:20px;' />
              </br>
              <span class='add'>新增</span>
            </li>
          </ul>
        </Panel>

      </Collapse>
    </section>
    <Modal v-model="edit" title='新增/修改' :mask-closable='false'>

      <Form label-position="top" :model='formItem' ref='formCustom'>
        <Row type="flex" justify="space-between">
          <Col span="11">
          <FormItem label="菜单名称">
            <Input v-model="formItem.name" type='text'></Input>
          </FormItem>
          </Col>
          <Col span="11">
          <FormItem label="排序">
            <InputNumber v-model="formItem.rank" style='width:100%;'></InputNumber>
          </FormItem>
          </Col>
        </Row>
        <Row type="flex" justify="space-between">
          <Col span="11">
          <FormItem label="图标">
            <Input v-model="formItem.icon" type='text'></Input>
          </FormItem>
          </Col>
          <Col span="11">
          <FormItem label="地址">
            <Input v-model="formItem.url" type='text'></Input>
          </FormItem>
          </Col>
        </Row>
        <Row type="flex" justify="space-between">
          <Col span="11">
          <FormItem label="父级菜单id">
            <Input v-model="formItem.parentId" type='text'></Input>
          </FormItem>
          </Col>
          <Col span="11">

          </Col>
        </Row>
        <FormItem label="下级栏目" v-if='formItem.id != "" && formItem.pid != 8888'>
          <Row v-for="(item, index) in detialList" :key="index" style='margin-bottom:20px'>
            <Col span="5">
            <Input v-model="item.name" type='text'></Input>
            </Col>
            <Col span="4" offset="1">
            <InputNumber v-model="item.rank"></InputNumber>
            </Col>
            <Col span="5" offset="1">
            <Input v-model="item.url"></Input>
            </Col>
            <Col span="3" offset="2">
            <Button @click="handleEdit(index, item)">修改</Button>
            </Col>
            <Col span="3">
            <Button @click="handleRemove(index, item)">删除</Button>
            </Col>
          </Row>
        </FormItem>
        <Row style='margin-bottom:30px;' v-if='formItem.id != "" && formItem.pid != 8888'>
          <Col span="5">
          <Input type='text' v-model='newAddData'></Input>
          </Col>
          <Col span="4" offset="1">
          <InputNumber v-model='newAddDataSort'></InputNumber>
          </Col>
          <Col span="5" offset="1">
          <Input type='text' v-model='newAddDataurl'></Input>
          </Col>
          <Col span="5" offset="1">
          <Button type="dashed" @click="handleAdd" icon="md-add">添加</Button>
          </Col>
        </Row>
      </Form>
      <div slot="footer" style='position:relative;clear:both'>

        <Button type="error" @click='removeItem' class='remove' icon="md-trash" v-if='formItem.id != ""'>删除</Button>
        <Button type="default" @click='edit = false' icon="md-close">取消</Button>
        <Button type="info" @click='update' icon="md-checkmark-circle-outline">保存</Button>
      </div>
    </Modal>
  </section>
</template>

<script>
import upImg from './upImg'
export default {
  name: 'school2',
  components: {
    upImg
  },
  data () {
    return {
      value1: '',
      gradelist: [],
      formItem: {},
      edit: false,
      curId: '',
      newAddDataurl: '',
      newAddData: '',
      newAddDataSort: 1,
      detialList: [],
    }
  },
  props: {
    fromheadschoolid: {
      default: -1
    }
  },

  mounted () {
    var that = this
    this.getGrade()

  },
  // filters:{
  // 	formateIcon(val){
  //     //console.log(val)
  //     return  val == undefined ? '' : val
  // 	},

  // },
  methods: {

    handleData () {

      var that = this
      that.axios.get('sysMenu/rootMenuJson', { params: { parentId: this.formItem.id } }).then(function (res, back) {

        that.detialList = res.data
        res.data.map(function (val, index) {
          val['rank'] = Number(val['rank'])
        })
        res.data = res.data.reverse()
        that.newAddDataSort = Number(res.data.length + 1)
      })
    },
    handleAdd () {
      var _index = this.detialList.length

      ////console.log(this.formItem.detialList[_index-1])
      var that = this
      if (this.newAddData == '') {
        this.$Message.info('名称不能为空')
        return false
      }
      this.newAddDataSort = ++_index
      var param = {
        icon: '',
        parentId: this.formItem.id,
        deleted: 0,
        name: this.newAddData,
        id: '',
        "actions": '',
        url: this.newAddDataurl,
        rank: this.newAddDataSort
      }

      //console.log(param)

      this.axios.post('sysMenu/save', { menubtn: JSON.stringify(param) }).then(res => {
        that.$Message.info('成功')
        that.newAddData = ''
        that.newAddDataurl = ''
        that.getGrade()
        that.handleData()
        that.detialList.push({
          name: '',
          index: _index++,
        });
      })
    },
    handleEdit (index, item) {
      //console.log(item,'index')

      var that = this
      //   this.$Modal.confirm({
      //     title: '提示',
      //     content: '<p>是否确认修改？</p>',
      //     onOk: () => {

      var param = {
        icon: '',
        parentId: item.parentId,
        deleted: 0,
        name: item.name,
        id: item.id,
        "actions": '',
        url: item.url,
        rank: item.rank
      }
      that.axios.post('sysMenu/save', { menubtn: JSON.stringify(param) }).then(res => {
        //console.log(res)
        that.$Message.success(res.msg)
      }).catch(function (res) {
        that.$Message.error('未知问题')
      })
      // },
      // onCancel: () => {

      // }
      // });
    },
    handleRemove (index, item) {
      var that = this
      this.$Modal.confirm({
        title: '提示',
        content: '<p>是否确认删除？</p>',
        onOk: () => {
          var _items = that.detialList
          _items.splice(index, 1)
          that.detialList = _items
          that.axios.post('sysMenu/delete', { id: item.id }).then(res => {
            //console.log(res)
            that.$Message.success(res.msg)
          }).catch(function (res) {
            that.$Message.error('未知问题')
          })
        },
        onCancel: () => {

        }
      });

    },
    upImglist (e) {
      //console.log(e)
      var str = []
      var _img = e.pics
      _img.map(function (val, index) {
        var pic = val['response']['data']['file']
        //console.log(pic)
        str.push(pic.split("@")[0])
      })
      //console.log(str)
      this.storepic = str.join(',')
    },
    getxls (grade) {
      //console.log(grade)
      var arr = []
      if (grade.length == 0) {

      } else {
        for (var i = 0; i < grade.length; i++) {
          var obj = {}
          obj['name'] = grade[i]['年级']
          obj['classes'] = grade[i]['班级'].split('|')
          arr.push(obj)
        }
      }
      this.cSchoolDom(arr)
    },
    cSchoolDom (arr) {
      this.importArr = arr
      var that = this
      localStorage.setItem('schoolTree', '')
      for (var i = 0; i < arr.length; i++) {

        (function (i) {
          that.axios.post('school/save.do', { pid: that.curSchoolid, name: arr[i]['name'] }).then(res => {
            //console.log(i,arr.length-1,'this.searchData')
            if (i == arr.length - 1) {
              //console.log(i,'i')
              that.axios.get('school2/getQueryList.do', { params: { pid: that.curSchoolid, start: 0, length: 100 } }).then(back => {
                //console.log(back,back.data)
                var backData = back.data
                for (var j = 0; j < arr.length; j++) {
                  for (var k = 0; k < backData.length; k++) {
                    if (arr[j]['name'] == backData[k]['name']) {
                      arr[j]['id'] = backData[k]['id']
                    }
                  }
                }
                that.upClasses(arr)
              })
            }
          })
        })(i)
      }
    },
    upClasses (arr) {
      //console.log(arr)
      var that = this
      localStorage.setItem('schoolTree', '')
      for (var i = 0; i < arr.length; i++) {
        (function (i) {
          for (var j = 0; j < arr[i]['classes'].length; j++) {
            (function (j) {
              var param = {
                pid: arr[i]['id'],
                name: arr[i]['classes'][j],
                sort: j + 1
              }
              //console.log(param)
              that.axios.post('school/save.do', param).then(res => {
                if (i == arr.length - 1 && j == arr[i]['classes'].length - 1) {
                  that.getGrade(that.curSchoolid, function (data) {
                    that.gradelist = data
                  })
                }
              })
            })(j)
          }
        })(i)
      }
    },
    getGrade () {
      var that = this
      this.axios.get('sysMenu/rootMenuJson', { params: {} }).then(res => {
        //console.log(res,'getMenuTree')
        that.gradelist = res.data

      })
      this.axios.get('sysMenu/dataList', { params: {} }).then(res => {
        //console.log(res,'getMenuTree')
      })



      // utils.getSchoolData().then(res=>{
      //     var gradelist  = res.filter(function(val,index){
      //             val['icon'] = val['icon'] ? val['icon'] : ''
      //       return val['guid'] == 8888
      //     })

      //    that.gradelist = gradelist[0]['children']

      //    return gradelist[0]['children']
      // })
    },
    switchPanel (e) {
      //console.log(e)
      if (e.length > 0) {
        var id = e[0].split('name')[1]
        this.curId = id
      }

      // if(e[0] && e[0].length>0){
      // 	var index = e[0].split('name')[1]
      // 	var pid = this.gradelist[index]['id']
      // 	var that = this
      // 	this.getGrade(pid,function(data){
      // 		that.gradelist[index]['children'] = data
      // 	})
      // }


    },
    update () {
      //console.log(this.formItem,this.storepic)

      var name = this.formItem.name
      var that = this
      if (name == '') {
        this.$Message.info('名称不能为空')
        return false
      }

      var param = {
        "icon": this.formItem.icon,
        "parentId": this.formItem.parentId,
        "deleted": 0,
        "name": this.formItem.name,
        "rank": this.formItem.rank,
        "actions": '',
        "url": this.formItem.url,
        "id": this.formItem.id
      }
      //console.log(param)

      this.axios.post('sysMenu/save', { menubtn: JSON.stringify(param) }).then(res => {
        that.$Message.info('成功')
        that.edit = false
        that.getGrade()
      })
    },
    updateData (e, pid, index) {
      //console.log(e)
      this.treekey = Math.random()
      this.curIndex = index
      this.edittype = 1
      var that = this
      this.edit = true
      this.formItem = e


      //console.log(e.icon,this.treekey)


      if (pid != 8888 && this.formItem.id != '') {
        this.handleData()
      } else {
        this.detialList = []
      }
    },
    newClass (pid, index) {
      this.curIndex = index
      this.edittype = 1
      this.edit = true
      this.formItem = { "icon": '', "parentId": pid, "deleted": 0, "name": '', "rank": 1, "actions": "", "url": "", id: '' }

      if (pid != 8888 && this.formItem.id != '') {
        this.handleData()
      } else {
        this.detialList = []
      }
    },
    newGrade () {
      this.curIndex = -1
      this.edittype = 0
      this.edit = true
      this.formItem = { "icon": '', "parentId": 0, "deleted": 0, "name": '', "rank": 1, "actions": "", "url": "" }


    },
    editGrade (e, index) {
      this.curIndex = index
      this.edittype = 0
      this.edit = true
      this.formItem = e


    },
    updateSmall () {
      var that = this
      // if(name==''){
      // 	this.$Message.info('名称不能为空')
      // 	return false
      // }
      var param = {
        rootid: 'news',
        pid: this.formItem.pid,
        name: name,
        guid: this.formItem.id,
        remark: '',
        url: '',
        sort: this.formItem.sort
      }
      if (this.formItem.pid != 8888) {
        param['icon'] = this.storepic || this.formItem.icon
      }
      //console.log(param)
      return false
      this.axios.post('dic/save.do', param).then(res => {
        that.$Message.info('成功')
        that.edit = false
        that.getGrade()
      })
    },
    removeItem () {
      //console.log(this.formItem)
      var param = {
        id: this.formItem.id
      }
      var that = this
      //console.log(param)

      this.axios.post('sysMenu/delete', param).then(res => {
        //console.log(res)
        that.$Message.info('成功')
        that.edit = false
        that.getGrade()

        // if(that.edittype == 1){
        // 	that.gradelist[that.curIndex]['children'] = data
        // }else{
        // 	that.gradelist  = data
        // }

      })
    }
  }
}
</script>

<style scoped>
.tabelContent {
  margin-top: 20px;
}

.leaveStu {
  flex: 1;
  padding-right: 25px !important;
  /* overflow: scroll; */
  padding-bottom: 50px;
  padding-top: 20px;
  overflow-x: hidden;
}

.leaveStu .ivu-row:first-of-type {
  margin-top: 5px;
}

.leaveStu .ivu-row {
  margin-top: 20px;
  /* 	overflow:hidden; */
  position: relative;
}

.leaveStu .ivu-col {
  margin-right: 10px;
  /* float:left; */
}

.leaveStu .ivu-col:last-of-type {
  float: left;
}

.conheadRight {
  float: right;
  /* margin-right: 20px; */
}

.classes {
  overflow: hidden;
  padding: 10px;
  padding-bottom: 0px;
}

.wjnolit {
  float: left;
  margin-right: 10px;
  list-style: none;
  width: 110px;
  height: 140px;
  cursor: pointer;
  position: relative;
  text-align: center;
  overflow: hidden;
  margin-bottom: 20px;
}

.wjnolit h3 {
  font-size: 14px;
  height: 25px;
  line-height: 25px;
}

.wjnolit span {
  font-size: 11px;
}

.classlist {
  float: left;
  margin-right: 20px;
  list-style: none;
  border: 1px solid #f5f5f5;
  width: 110px;
  height: 110px;
  box-shadow: 0px 2px 10px 0px rgba(229, 229, 229, .8);
  border-radius: 8px;
  transition: all 2s;
  cursor: pointer;
  position: relative;
  text-align: center;
  overflow: hidden;
  margin-bottom: 20px;
  /* 	dislay:flex;
		justify-content: center; */

}

.classlist h3 {
  background: #92ce73;
  color: #fff;
  height: 30px;
  line-height: 30px;
  font-size: 14px;
  box-shadow: 0px 2px 10px 0px rgba(229, 229, 229, .8);
}

.classlist span {
  font-size: 12px;
  color: #999;
}

.classlist .invite {
  margin-top: 10px;
  font-size: 16px;
}

.remove {
  position: absolute;
  left: 0px;
  top: 0px;
}

.classlist .add {
  display: block;
  margin-top: 10px;
}

.removeGw {
  position: absolute;
  right: 16px;
  top: 10px
}

.ivu-collapse-header {
  font-weight: bold;
}

#sortStyle {
  font-size: 12px;
  color: #aaa
}

#gradenames {
  min-width: 40px;
  margin-right: 30px;
  display: inline-block;
}

.wjicon {
  width: 60px;
  height: 60px;
  display: block;
  margin: 10px auto;
}
</style>
